// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-group[data-v-11f759cf] >  .form-control:not(:first-child) {
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.input-group .input-group-text[data-v-11f759cf] {
  padding: 0.25rem;
  font-size: larger;
}
#jsPageEditor .input-group .input-group-text[data-v-11f759cf] {
  padding: 0.35rem;
  font-size: 22px;
  border-color: #787878;
}
`, "",{"version":3,"sources":["webpack://./lib/DatePicker.3.vue","webpack://./../DatePicker.3.vue"],"names":[],"mappings":"AAGI;EACI,+BAAA;EACA,kCAAA;ACFR;ADDA;EAMQ,gBAAA;EACA,iBAAA;ACFR;ADGQ;EACI,gBAAA;EACA,eAAA;EACA,qBAAA;ACDZ","sourcesContent":["\n@import \"/styles/SiteColors.less\";\n.input-group {\n    & > ::v-deep(.form-control:not(:first-child)) {\n        border-top-left-radius: 0.25rem;\n        border-bottom-left-radius: 0.25rem;\n    }\n    .input-group-text {\n        padding: 0.25rem;\n        font-size: larger;\n        #jsPageEditor & {\n            padding: 0.35rem;\n            font-size: 22px;\n            border-color: @primary-lightest;\n        }\n    }\n}\n",".input-group > ::v-deep(.form-control:not(:first-child)) {\n  border-top-left-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n}\n.input-group .input-group-text {\n  padding: 0.25rem;\n  font-size: larger;\n}\n#jsPageEditor .input-group .input-group-text {\n  padding: 0.35rem;\n  font-size: 22px;\n  border-color: #787878;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
